module.exports = __webpack_public_path__ + "static/MoscowAffiliateSummit-0be8d1caffa71d4a399750f6850140a3.jpg";